import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '16px',
        marginBottom: '24px',
      }}
    >
      <div>
        <h1
          style={{
            fontSize: '32px',
            fontWeight: '700',
            margin: 0,
            color: '#111827',
          }}
        >
          {title}
        </h1>
        {subtitle && (
          <p style={{ fontSize: '14px', color: '#6b7280', margin: '8px 0 0' }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>{actions}</div>}
    </div>
  );
}
